export enum MetadataConnectionType {
  MetadataElement = 'metadataElement',
  FunnelStep = 'funnelStep',
}

export interface MetadataElementConnection {
  type: MetadataConnectionType.MetadataElement;
  crmOrgId: string;
  metadataId: string;
}

export interface FunnelStepConnection {
  type: MetadataConnectionType.FunnelStep;
  funnelId: string;
  stageId: string;
}

export type MetadataConnection = MetadataElementConnection | FunnelStepConnection;

export enum EnrichTargetType {
  MetadataElement = 'metadataElement',
  AllMetadataFromFunnelMap = 'allMetadataFromFunnelMap',
}

export interface EnrichMetadataElementTarget {
  type: EnrichTargetType.MetadataElement;
  metadataElementId: string;
}

export interface EnrichAllMetadataFromFunnelMapTarget {
  type: EnrichTargetType.AllMetadataFromFunnelMap;
  funnelMapId: string;
}

export type EnrichTarget = EnrichMetadataElementTarget | EnrichAllMetadataFromFunnelMapTarget;

export enum EnrichContextType {
  FunnelMap = 'funnelMap',
  FunnelStep = 'funnelStep',
  AllStepsFromFunnel = 'allStepsFromFunnel',
}

export interface EnrichFunnelMapContext {
  type: EnrichContextType.FunnelMap;
  funnelMapId: string;
}

export interface EnrichFunnelStepContext {
  type: EnrichContextType.FunnelStep;
  funnelId: string;
  stageName: string;
}

export interface EnrichAllStepsFromFunnelContext {
  type: EnrichContextType.AllStepsFromFunnel;
  funnelId: string;
}

export type EnrichContext =
  | EnrichFunnelMapContext
  | EnrichFunnelStepContext
  | EnrichAllStepsFromFunnelContext;

export interface EnrichMetadataElementsRequest {
  targets: EnrichTarget[];
  context?: EnrichContext[];
  parentElementId?: string;
  commonChildId?: string;
}

export interface EnrichedMetadataElement {
  name: string;
  type: string;
  metadataId: string;
  crmOrgId: string;
  dependencyConnections: MetadataElementConnection[];
  usedByConnections: MetadataConnection[];
  cardType?: 'field' | 'configuration' | 'object';
  color?: string;
  icon?: string;
}
